import { Customer } from './common';
import { Ticket } from './ticket';
import { User } from './user';

export type TicketTypeResponse = {
  ID: number;
  default_description: string;
  default_priority: number;
  desc: string;
  task_type_ID: number;
  default_tech_visibility: 1 | 0;
};

export type NoteType = {
  ID: number;
  desc: string;
  active: 1 | 0;
  tech_visible: 1 | 0;
};

export enum LinkType {
  Customer = 'C',
  Technician = 'T',
  Other = 'O',
}

export type TaskData = {
  ID: number;
  task_type_ID: number;
  record_ID: number;
  creation_date: string;
  due_date: string;
  assigned_ID: number;
  locked: number;
  location: number;
  task_links: {
    customer?: Customer;
    ticket?: Ticket;
    technician?: {
      ID: number;
      email: string;
      mobile: string[];
      name: string;
    };
  };
  task_var_links: any[];
  record: {
    ID: number;
    type: number;
    created_at: string;
    created_by: number;
    open: number;
    customer_ID: number;
    technician_ID: number;
    job_ID: number;
    description: string;
    priority: string;
    due_date: string;
    eta_date: string;
    closed_at: string;
    closed_by: number;
    email_sent: number;
    open_type: string;
    assigned: number;
    tech_visible: number;
    created_by_user: string;
  };
  user: User;
};
